import storeRoot from "../store-root";
import http from "../../service/api";
import queryString from "querystring";

const moduleName = "deviceSettingsModule";

storeRoot.registerModule(moduleName, {
  namespaced: true,

  actions: {
    // 获取基地KeyValue 值
    async getBaseKeyValue({ commit }, payload) {
      let result = await http.get("/api/FishBase/KeyValue");
      return result.data;
    },
    // 根据基地获取塘口值
    async getFishPond({ commmit }, payload) {
      let result = await http.get(`/api/FishPond/KeyValue/${payload}`);
      return result.data;
    },

    // 获取设备列表
    async getEquipmentList({ commit }, payload) {
      let result = await http.get(
        `/api/Equipment/GetEquipmentList?${queryString.stringify(payload)}`
      );
      return result.data;
    },

    // 增加设备
    async addEquipment({ commit }, payload) {
      let result = await http.post(`/api/Equipment`, payload);
      return result.data;
    },
    // 删除设备
    async deleteEquipment({ commit }, payload) {
      let result = await http.delete(`/api/Equipment/${payload}`);
      return result;
    },
    // 获取单个设备数据
    async getEditView({ commit }, payload) {
      let result = await http.get(`/api/Equipment/GetEditView/${payload}`);
      return result.data;
    },
    // 编辑设备
    async editEquipment({ commit }, payload) {
      let result = await http.put(`/api/Equipment/${payload.id}`, payload.arr);
      return result.data;
    },
    // 校准溶解氧
    async calibrationDissolvedOxygen({ commit }, payload) {
      let result = await http.put(
        `/api/EquipmentSocket/CalibrationDissolvedOxygen?id=${payload}`
      );
      return result.data;
    },
    //通过设备号获取设备信息（用于判断是否显示传感器类型下拉框
    async getSensorType({ commit }, payload) {
      let result = await http.get(`/api/Equipment/GetEuipmentInfo/${payload}`);
      return result.data;
    },
    // 获取传感器类型下拉列表
    async getSensorTypeList({ commit }, payload) {
      let url = `/api/EquipmentSocket/GetSensorTypeList`
      if(payload){
        url += `?deviceType=${payload}`
      }
      let result = await http.get(url);
      return result.data;
    }
  },
  mutations: {}
});

export default moduleName;
